const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
      background: theme.colors[4],
      color: theme.colors[1],
      paddingTop: (props) => props.headerHeight,
    },
    wrapper: {
      extend: theme.wrapper,
    },
    description: {
      marginTop: 75,
    },
    insurance: {
      marginTop: 120,
    },
    textWrapper: {
      marginTop: 120,
      marginBottom: 120,
      '& $text': {
        width: '60%',
        margin: '0 auto',
      },
    },
    text: {},
  }

  output[theme.mediaInverse.md] = {
    textWrapper: {
      '& $text': {
        width: '80%',
      },
    },
    text: {},
  }

  output[theme.mediaInverse.sm] = {
    textWrapper: {
      '& $text': {
        width: '100%',
      },
    },
    text: {},
  }

  return output
}

export default style
